<template>
  <div class="personal-info-container">
<!--    <div class="header">
      <h1>欢迎回来！</h1>
      <button class="logout-btn" @click="logout">退出登录</button>
    </div>-->
    <div class="content-wrapper" :style="{ backgroundImage: `url(${backgroundImageUrl})` }">
<!--      <div class="api-test-section">
        <h2>API 接口测试</h2>
        <div class="test-buttons">
          <button class="test-btn" @click="getCurrentUserInfo" :disabled="loading">
            {{ loading ? '加载中...' : '获取当前用户信息' }}
          </button>
          <button class="test-btn" @click="getUserList" :disabled="loading">
            {{ loading ? '加载中...' : '获取用户列表' }}
          </button>
        </div>
        
        &lt;!&ndash; 当前用户信息展示 &ndash;&gt;
        <div v-if="currentUser" class="user-info-card">
          <h3>当前用户信息</h3>
          <div class="user-details">
            <p><strong>邮箱:</strong> {{ currentUser.email }}</p>
            <p><strong>昵称:</strong> {{ currentUser.nickname }}</p>
            <p><strong>身高:</strong> {{ currentUser.height }}cm</p>
            <p><strong>体重:</strong> {{ currentUser.weight }}kg</p>
            <p><strong>体型:</strong> {{ currentUser.bodyType }}</p>
            <p><strong>登录时间:</strong> {{ currentUser.loginTime }}</p>
          </div>
        </div>

        &lt;!&ndash; 用户列表展示 &ndash;&gt;
        <div v-if="userList.length > 0" class="user-list-section">
          <h3>用户列表</h3>
          <div class="user-list">
            <div v-for="user in userList" :key="user.email" class="user-item">
              <div class="user-avatar">
                <img :src="user.avatarUrl" :alt="user.nickname" @error="handleImageError">
              </div>
              <div class="user-info">
                <h4>{{ user.nickname }}</h4>
                <p>{{ user.email }}</p>
                <p>{{ user.height }}cm / {{ user.weight }}kg</p>
                <p>体型: {{ user.bodyType }}</p>
                <small>{{ user.loginTime }}</small>
              </div>
            </div>
          </div>
        </div>

        &lt;!&ndash; 错误信息展示 &ndash;&gt;
        <div v-if="error" class="error-message">
          <p>{{ error }}</p>
        </div>
      </div>-->
      <PersonalInfoForm @next="handleNext" />

    </div>
  </div>
</template>

<script setup>
import PersonalInfoForm from '@/components/PersonalInfoForm.vue'
import { useRouter } from 'vue-router'
import { ref, onMounted } from 'vue'
import authUtils from '@/utils/auth'
import UserInfoApi from '@/api/userInfo'
import { getOssResourceUrl, preloadImageWithFallback } from '@/utils/ossResource'
const showInlineDialog = ref(false)
const inlineStepData = ref(null)
const handleNext = (stepData) => {
  // 现在组件切换逻辑在PersonalInfoForm内部处理
  // 这里可以处理其他需要的逻辑，比如保存数据到全局状态等
  console.log('PersonalInfo 接收到表单数据:', stepData)
  inlineStepData.value = stepData
  // 不再设置 showInlineDialog，因为切换逻辑在子组件内部
}

const router = useRouter()
const loading = ref(false)
const error = ref('')
const currentUser = ref(null)
const userList = ref([])

const logout = () => {
  // 清除所有认证信息

  authUtils.clearAuth()
  // 跳转到登录页面
  router.push('/')
}

// 获取当前用户信息
const getCurrentUserInfo = async () => {
  loading.value = true
  error.value = ''
  try {
    currentUser.value = await UserInfoApi.getCurrentUserInfo()
  } catch (err) {
    error.value = '获取用户信息失败: ' + (err.message || err)
    console.error('获取用户信息失败:', err)
  } finally {
    loading.value = false
  }
}

// 获取用户列表
const getUserList = async () => {
  loading.value = true
  error.value = ''
  try {
    userList.value = await UserInfoApi.getUserList()
  } catch (err) {
    error.value = '获取用户列表失败: ' + (err.message || err)
    console.error('获取用户列表失败:', err)
  } finally {
    loading.value = false
  }
}

// 处理图片加载错误
const handleImageError = (event) => {
  const target = event.target
  target.src = 'https://via.placeholder.com/50x50?text=Avatar'
}

// 背景图片 URL
const backgroundImageUrl = ref('')

// 加载背景图片
onMounted(async () => {
  // 尝试多个可能的路径（因为字体路径是 font/Pin.ttf，图片可能在 public/image/ 或 image/）
  const possiblePaths = [
    // 'public/image/background.jpg',  // 尝试 public/ 前缀
    'image/background.jpg',          // 尝试直接路径
  ]
  
  console.log('[背景图片] 开始加载，尝试路径:', possiblePaths)
  console.log('[背景图片] OSS CDN 配置:', process.env.VUE_APP_OSS_CDN || '未配置')
  console.log('[背景图片] 字体路径参考: /oss-resource/font/Pin.ttf')
  
  // 按顺序尝试每个路径
  for (const ossPath of possiblePaths) {
    const ossUrl = getOssResourceUrl(ossPath)
    console.log(`[背景图片] 尝试路径: ${ossPath} -> 代理URL: ${ossUrl}`)
    
    if (ossUrl) {
      const finalUrl = await preloadImageWithFallback(ossUrl, null)
      if (finalUrl) {
        console.log(`[背景图片] ✅ 成功加载: ${ossPath}`)
        backgroundImageUrl.value = finalUrl
        return // 成功加载，退出
      } else {
        console.warn(`[背景图片] ❌ 路径失败: ${ossPath}`)
      }
    }
  }
  
  console.error('[背景图片] 所有路径都失败，不设置背景图片')
})
</script>

<style scoped>
.personal-info-container {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  background: #1e3c72; /* 备用纯色背景 */
}

.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
}

.header h1 {
  color: #e8ecf3;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}

.logout-btn {
  padding: 8px 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.2);
  color: #e8ecf3;
  border: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.content-wrapper {
    overflow: hidden;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  /*padding: 170px 20px 20px;*/
  /* background-image 通过 :style 动态绑定 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  overflow-y: auto;
}

.api-test-section {
  width: 100%;
  max-width: 800px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.api-test-section h2 {
  color: #e8ecf3;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  text-align: center;
}

.test-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 24px;
}

.test-btn {
  padding: 10px 20px;
  border-radius: 20px;
  background: rgba(166, 245, 93, 0.8);
  color: #2b2f2e;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  min-width: 120px;
}

.test-btn:hover:not(:disabled) {
  background: rgba(166, 245, 93, 1);
  transform: translateY(-1px);
}

.test-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.user-info-card {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.user-info-card h3 {
  color: #a6f55d;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
}

.user-details p {
  color: #e8ecf3;
  font-size: 14px;
  margin-bottom: 8px;
  line-height: 1.4;
}

.user-list-section {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.user-list-section h3 {
  color: #a6f55d;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
}

.user-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
}

.user-item {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info {
  flex: 1;
}

.user-info h4 {
  color: #e8ecf3;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

.user-info p {
  color: rgba(232, 236, 243, 0.8);
  font-size: 12px;
  margin-bottom: 2px;
  line-height: 1.3;
}

.user-info small {
  color: rgba(232, 236, 243, 0.6);
  font-size: 11px;
}

.error-message {
  background: rgba(255, 0, 0, 0.1);
  border: 1px solid rgba(255, 0, 0, 0.3);
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}

.error-message p {
  color: #ff6b6b;
  font-size: 14px;
  margin: 0;
}

</style>
